import classNames from "classnames";
import styles from "./ExpertGroupPopup.module.scss";
import AnimatedPopup from "../AnimatedComponents/AnimatedPopup";
import { useDispatch, useSelector } from "react-redux";
import { getDitaContent, selectDitaContent } from "../Content/ContentSlice";
import { useTableOfContents } from "../../hooks/tableOfContentsHooks/useTableOfContents";
import { selectDitaPath } from "../../features/counter/counterSlice";
import useAppModernisation from "../../hooks/useAppModernisation";
import colours from "../AppTopicBanner/apptopicbanner.module.scss";
import { getExpertGroup } from "./ExpertGroupUtils";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { createUrlFromDitaFilename } from "../../utils/formatters/createUrlFromDitaFilename";

const ExpertGroupPopup = ({ isExpanded, expandSideBar }) => {
  const tableOfContents = useTableOfContents();
  const content = useSelector(selectDitaContent);
  const ditapath = useSelector(selectDitaPath);
  const { isMobileView } = useAppModernisation();
  const expertGroupRef = useRef(null);
  const navigate = useNavigate();

  let expertGroup;
  const dispatch = useDispatch();
  const expertGroupList = getDitaContent("Contributors/EGMs_Reltable.ditamap", content, dispatch);
  if (
    expertGroupList &&
    (tableOfContents?.tableOfContents?.href || tableOfContents?.tableOfContents?.id)
  ) {
    const topLevelGuideline = tableOfContents?.tableOfContents?.href
      ? tableOfContents?.tableOfContents?.href
      : tableOfContents?.tableOfContents?.id;
    expertGroup = getExpertGroup(
      expertGroupList,
      decodeURIComponent(topLevelGuideline),
      content,
      dispatch,
    );
  }

  useEffect(() => {
    if (!expertGroup?.length || !expertGroupRef.current) return;

    const handleLinkClick = (e) => {
      e.preventDefault();

      let href = e.currentTarget.getAttribute("href");
      if (!href) return;

      if (href.includes(".dita")) {
        href = createUrlFromDitaFilename(href);
      }

      if (href.includes(".pdf") && href.includes("/PDFs/")) {
        window.open(
          `https://ccmsfiles.tg.org.au/${import.meta.env.REACT_APP_CCMS_VERSION}/PDFs/${href.split("/PDFs/")[1]}`,
          "_blank",
          "noopener,noreferrer",
        );
      } else if (!href.startsWith("http://") && !href.startsWith("https://")) {
        navigate(href);
      } else {
        window.open(href, "_blank", "noopener,noreferrer");
      }
    };

    const container = expertGroupRef.current;
    const xrefs = container.querySelectorAll("xref");

    xrefs.forEach((xref) => {
      xref.addEventListener("click", handleLinkClick);
    });

    return () => {
      xrefs.forEach((xref) => {
        xref.removeEventListener("click", handleLinkClick);
      });
    };
  }, [isExpanded, expertGroup?.length, navigate]);

  return (
    <div>
      <AnimatedPopup show={isExpanded} direction={isMobileView ? "bottom" : "right"} zIndex="2001">
        <div className={classNames("size-20 semibold", styles.expertPopup)}>
          <div
            className={classNames(styles.headerBar, {
              [colours[ditapath?.replace("/", "")]]: isMobileView,
            })}
          >
            <div className={styles.contributorHeader}>Expert contributors</div>
            <i
              className={classNames("tg-icons-Cross size-24", styles.closeIcon)}
              onClick={expandSideBar}
            ></i>
          </div>
          <div ref={expertGroupRef} className={styles.contributors}>
            {expertGroup && <div>{expertGroup}</div>}
          </div>
        </div>
      </AnimatedPopup>
      <div onClick={expandSideBar} className={isExpanded ? styles.greyedOut : ""}></div>
    </div>
  );
};

export default ExpertGroupPopup;
